<template>
  <div class="tag-container cling">
    <div v-if="(tag.template === 'cover' && tag.meta.showTag) || tag.template === 'customEmbed'" :class="[{'is-shown': frame}, tag.template]" :style="coverStyle">
      <iframe ref="iFrame" allowfullscreen="false" allowTransparency="true" frameBorder="0" scrolling="no" :src="coverURL" width="100%" height="100%"></iframe>
    </div>
    <shopTag v-else-if="tag.template === 'ptag' && tag.meta.showTag" v-bind:style="[dotStyle]" :dimensions="dimensions" :meta="tag.meta" :key="tag.id" :frame="frame" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:action="onAction" v-on:videoaction="onVideoAction" />
    <textBoxTag v-else-if="tag.template === 'textbox' && tag.meta.showTag" v-bind:style="[dotStyle]" :dimensions="dimensions" :meta="tag.meta" :key="tag.id" :frame="frame" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:videoaction="onVideoAction" v-on:action="onAction" />
    <logicTag v-else-if="tag.template === 'logic'" :meta="tag.meta" :key="tag.id" :frame="frame" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]"  v-on:action="onAction" v-on:videoaction="onVideoAction" />
    <filterTag v-else-if="tag.template === 'filter'" :meta="tag.meta" :key="tag.id" :frame="frame" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:videoaction="onVideoAction" />
    <simpleTextFormTag v-else-if="tag.template === 'simpleTextForm'" :meta="tag.meta" :key="tag.id" :frame="frame" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:show="show" v-on:hide="hide" />
    <hotSpotTag v-else-if="tag.template === 'hotspot'" v-bind:style="[dotStyle]" v-bind:hotspot="tag" :dimensions="dimensions"  :meta="tag.meta" :key="tag.id" :frame="frame"  :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]"  v-on:action="onAction" v-on:videoaction="onVideoAction"></hotSpotTag>
    <hotdot v-else-if="tag.template === 'hotdot'" v-bind:style="[dotStyle]" v-bind:hotdot="tag" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]"  v-on:action="onAction" v-on:videoaction="onVideoAction"></hotdot>
    <buttonTag v-else-if="tag.template === 'buttonTag'" v-bind:style="[dotStyle]" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]"  v-on:action="onAction" v-on:videoaction="onVideoAction"/>
    <imageTag v-else-if="tag.template === 'imageTag' && tag.meta.showTag" v-bind:style="[dotStyle]" :meta="tag.meta" :dimensions="dimensions" :key="tag.id" :frame="frame"  :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]"  v-on:action="onAction" v-on:videoaction="onVideoAction"/>
    <singleChoiceTag v-else-if="tag.template === 'singleChoice'" :class="{'is-shown': isInfoActive && frame}" v-bind:singleChoice="tag" :dimensions="dimensions" :meta="tag.meta" :key="tag.id" :frame="frame" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:show="show" v-on:hide="hide"  v-on:action="onAction" v-on:videoaction="onVideoAction"></singleChoiceTag>
    <quizTag v-else-if="tag.template === 'quiz'" :class="{'is-shown': isInfoActive && frame}" :meta="tag.meta" :key="tag.id" :frame="frame" :dimensions="dimensions" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:show="show" v-on:action="onAction" v-on:hide="hide" />
    <quizzesTag v-else-if="tag.template === 'quizzes'" :class="{'is-shown': isInfoActive && frame}" :meta="tag.meta" :key="tag.id" :frame="frame" :dimensions="dimensions" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:show="show" v-on:action="onAction" v-on:hide="hide" />
    <div v-else-if="tag.meta.showTag">
      <div class="dot" v-bind:style="[dotStyle]" @click="onDotClick" @mouseenter="onDotMouseEnter" @mouseleave="onDotMouseLeave">
        <div class="dot__item" v-bind:class="dotItemClz">
          <i v-if="dotItemIcon" class="material-icons">{{dotItemIcon}}</i>
        </div>
      </div>
      <svg class="line" viewBox="0 0 100 100" preserveAspectRatio="none" v-bind:style="[svgStyle]">
        <line :x1="50" :y1="50" :x2="svgLinePosition.x" :y2="svgLinePosition.y" />
      </svg>
      <div class="info" :class="{'is-shown': isInfoActive && frame}" v-on:mouseenter="mouseEnter" @mouseleave="mouseLeave" v-bind:style="[infoStyle]">
        <dynamic2 :templateId="currentTemplate" :meta="tag.meta" :dimensions="dimensions" :isLastFrame="frames[currentFrame] && !frames[currentFrame+5]" v-on:videoaction="onVideoAction" v-on:action="onInfoAction"></dynamic2>
      </div>
    </div>
  </div>
</template>
<script>
import dot from './dot'
import dynamic2 from './dynamic2'
import quizTag from './quizTag'
import quizzesTag from './quizzesTag'
import hotSpotTag from './hotSpotTag'
import singleChoiceTag from './singleChoiceTag'
import hotdot from './hotDot'
import buttonTag from './buttonTag'
import imageTag from './ImageTag'
import simpleTextFormTag from './simpleTextFormTag'
import textBoxTag from './textBoxTag'
import shopTag from './shopTag'
import logicTag from './logicTag'
import filterTag from './filterTag'
import templates from './templates'
import { extractWaypoints, groupBy, interpolate } from './utils'
import { base, coverURL } from './mixins/multilang'

export default {
  name: 'tag',
  components: {
    dot,
    dynamic2,
    quizTag,
    quizzesTag,
    simpleTextFormTag,
    hotSpotTag,
    logicTag,
    hotdot,
    textBoxTag,
    shopTag,
    singleChoiceTag,
    filterTag,
    buttonTag,
    imageTag
  },
  mixins: [base, coverURL],
  created() {
    if (document.documentMode || /Edge/.test(navigator.userAgent)) {
       this.legacyRenderMode = true
    }
  },
  mounted() {
    console.log('tag mounted', this.tag.id)
    this.isInfoActive = this.tag.meta.initalShow || false // this.tag.meta.initialShow
    if (this.tag.template === 'cover' || this.tag.template === 'customEmbed') {
      console.log('mounted cover / customEmbed', this.tag.template)
      var iFrameWindow = this.$refs.iFrame.contentWindow
      setInterval(() => {
        // no need to post any messages if we are not inside the activ window for this frame
        // console.log("frames: curentFrame", this.frames, this.currentFrame)
        if (!this.frames[this.currentFrame - 10] && !this.frames[this.currentFrame + 10]) {
          return
        }
        var transfer = {}
        transfer.currentTime = this.videoElement.currentTime
        transfer.playbackRate = this.videoElement.playbackRate
        // transfer payload data
        transfer.tag = this.tag
        // the iframe is mounted but is it active as well
        transfer.active = this.frames[this.currentFrame]
        // the acticity of the iframe is aboout to end. can be used as an indicator for fade out etc.
        transfer.isEnding = this.frames[this.currentFrame] && !this.frames[this.currentFrame + 15]
        // console.log(iFrameWindow)
        iFrameWindow.postMessage(transfer, '*')
        console.log('postMessage')
      }, 250)
       // get reference on video
      this.$nextTick(() => {
        const el = document.getElementById(this.videoId)
        if (this.videoId && el) {
          this.videoElement = el
        } else {
          console.error('Cling:Viewer: VideoTag not found')
        }
      })
    }
  },
  props: {
    tag: {
      type: Object,
      default: function () {
        return {}
      }
    },
    currentFrame: Number,
    duration: Number,
    dimensions: Object,
    videoId: String,
    size: {
      type: Object,
      default: function () {
        return {
          x: 100,
          y: 50
        }
      }
    }
  },
  data() {
    return {
      tagOffset: {
        x: 25,
        y: 25
      },
      dot: null,
      active: false,
      line: { x: 100, y: 100 },
      animation: null,
      isInfoActive: false,
      infoDimensions: null,
      templates: templates,
      legacyRenderMode: false
    }
  },
  computed: {
    frames: function () {
      // console.log('frames')
      var frames = []
      var wpsbt = null
      try {
        wpsbt = groupBy(this.waypoints, 'timeAsFragment')
      } catch (e) {
        console.log(e)
      }
      var last = null
      for (var index = 0; index < this.duration; index++) {
        var wpbt = wpsbt[index]
        var frame = null
        if (wpbt) {
          frame = wpbt[0]
          last = frame
        } else if (last) {
          if (!last.next) {
            last = null
          } else {
            var next = this.waypointById(last.next)
            var diff = next.timeAsFragment - last.timeAsFragment
            var pos = index - last.timeAsFragment
            frame = interpolate(last, next, pos / diff)
          }
        }
        // console.log('push frame', frame)
        frames.push(frame)
      }
      // console.log('frames', frames)
      return frames
    },
    waypoints: function () {
      return this.tag.scenes.length ? extractWaypoints(this.tag.scenes) : []
    },
    waypointsById: function () {
      var wpbId = groupBy(this.waypoints, 'id')
      return wpbId
    },
    frame: function () {
      // console.log('current frame', this.currentFrame)
      return this.frames[this.currentFrame] // || { x: 0, y: 0 }
    },
    currentTemplate: function () {
      return this.tag.template // this.templates[this.tag.template] ? this.templates[this.tag.template] : this.templates['generic']
    },
    dotPos: function () {
      if (this.frame) {
        return {
          x: this.frame.x * this.dimensions.w,
          y: this.frame.y * this.dimensions.h
        }
      } else {
        return { x: this.dimensions.w * 0.5, y: this.dimensions.h * 0.5 }
      }
    },
    dotStyle: function () {
      if (this.frame) {
        let ds = {
          'display': this.tag.template === 'ptag' ? 'inline-block' : 'block'
        }
        if (!this.legacyRenderMode) {
          ds['transform'] = `translate(${this.dotPos.x}px, ${this.dotPos.y}px)`
        } else {
          ds['left'] = `${this.dotPos.x}px`
          ds['top'] = `${this.dotPos.y}px`
          ds['position'] = `absolute`
          ds['transition'] = 'top 100ms linear 0, left 100ms linear 0'
        }
        return ds
      } else {
        return {
          display: 'none'
        }
      }
    },
    coverStyle: function() {
      if (this.tag.template !== 'cover' && this.tag.template !== 'customEmbed') {
        return null
      }
      /*
      var meta = this.tag.meta
      console.log('cover.styles', meta.top, meta.bottom, meta.width, meta.height)
      return {
        'top': meta.top || 'initial',
        'left': meta.left || 'initial',
        'bottom': meta.bottom || 'initial',
        'right': meta.right || 'initial',
        'width': meta.width || '100%',
        'height': meta.height || '100%'
      }
      */
     if (!this.frame) {
       return null
     }
      let ds = {}
      let w = this.frame.pw * this.dimensions.w
      let h = this.frame.ph * this.dimensions.h
      ds['transform'] = `translate(${this.dotPos.x - w / 2}px, ${this.dotPos.y - h / 2}px)`
      ds['width'] = `${w}px`
      ds['height'] = `${h}px`
      return ds
    },
    infoBox: function () {
      let dotPos = this.dotPos
      let iSize = this.infoSize
      let box = iSize
      box.x = dotPos.x + this.tagOffset.x
      box.y = dotPos.y + this.tagOffset.y
      // let offX = this.tagOffset.x
      // let offY = this.tagOffset.y
      // console.log('infoBox', box)
      if (this.frame.y > 0.5) {
        box.y = dotPos.y - iSize.h - this.tagOffset.y
      }
      if (this.frame.x > 0.5) {
        box.x = dotPos.x - iSize.w - this.tagOffset.x
      }
      return box
    },
    infoSize: function () {
      if (!this.infoDimensions) {
        let infoEl = this.$el.querySelector('.info')
        this.infoDimensions = infoEl.getBoundingClientRect()
        // console.log('calculate size of info box', this.infoDimensions)
        return {
          w: this.infoDimensions.width,
          h: this.infoDimensions.height
        }
      } else {
        return null
      }
    },
    infoStyle: function () {
      if (this.tag.quiz) {
        return {
          width: '100%',
          height: '100%',
          'z-index': 1,
          'max-width': 'none'
        }
      } else if (!this.frame || !this.isInfoActive) {
        let dp = this.dotPos
        return {
          // 'visibility': 'hidden',
          // 'opacity': 0,
          transform: `translate(${dp.x}px, ${dp.y}px)`
        }
      } else {
        let box = this.infoBox
        // let x = this.frame.x * this.dimensions.w
        // let y = this.frame.y * this.dimensions.h
        // let offX = this.offset.x // this.frame.x < 0.5 ? 100 : -(100 + 200)
        // let offY = this.offset.y // < 0.5 ? -(100 + 100) : 100
        // console.log('f, size', x, y, this.dimensions, this.size)
        const style = {
          // top: `-${offY}px`,
          // left: `${offX}px`,
          // visibility: 'visible',
          // opacity: 1,
          width: `${box.w}px`,
          // height: `${box.h}px`,
          transform: `translate(${box.x}px, ${box.y}px)`
        }
        return style
      }
    },
    linePosition: function () {
      return {
        x: 0,
        y: 0
      }
    },
    svgLinePosition: function () {
      if (this.frame) {
        return {
          x: this.frame.x < 0.5 ? 100 : 0,
          y: this.frame.y < 0.5 ? 100 : 0
        }
      } else {
        return {
          x: 50, // Default middle
          y: 50
        }
      }
    },
    svgStyle: function () {
      // console.log('line frame', this.frame)
      if (this.frame && this.isInfoActive) {
        let x = this.frame.x * this.dimensions.w
        let y = this.frame.y * this.dimensions.h
        const style = {
          width: this.tagOffset.x * 2 + 8 + 'px',
          height: this.tagOffset.y * 2 + 8 + 'px',
          transform: `translate(${x - this.tagOffset.x - 4}px, ${y - this.tagOffset.y - 4}px)`
        }
        return style
      } else {
        return { 'display': 'none' }
      }
    },
    dotItemClz: function () {
      return ['pulse', (this.tag.meta.icon ? 'icon-' + this.tag.meta.icon : '')]
    },
    dotItemIcon: function () {
      return this.tag.meta.icon
    }
  },
  methods: {
    activate: function () {
      this.active = true
      this.$emit('activate')
    },
    deactivate: function () {
      this.active = false
      this.$emit('deactivate')
    },
    waypointsByKey(key) {
      return groupBy(this.waypoints, key)
    },
    waypointById(id) {
      return this.waypointsById[id][0]
    },
    onDotClick: function (e) {
      console.log('onDotClick', e)
      this.isInfoActive = !this.isInfoActive
      // this.$emit('activate')
    },
    onDotMouseEnter(e) {
      console.log('onDotMouseEnter', e)
      this.$emit('videoaction', {
        'action': 'pause'
      })
    },
    onDotMouseLeave(e) {
      console.log('onDotMouseLeave', e)
      if (!this.isInfoActive) {
        this.$emit('videoaction', {
          'action': 'play'
          })
      }
    },
    mouseEnter(e) {
      this.$emit('videoaction', {
        'action': 'pause'
        })
    },
    mouseLeave(e) {
      if (!this.tag.quiz) {
        this.$emit('videoaction', {
          'action': 'play'}
          )
      }
    },
    show() {
      this.isInfoActive = true
    },
    hide() {
      this.isInfoActive = false
    },
    onOpen(value) {
      this.$emit('open', value)
    },
    onAction(value) {
      this.$emit('action', value)
    },
    // special treatmentfor the dynamic tags
    onInfoAction(action) {
      console.log("onInfoAction", action)
      if (action.action === "close") {
        this.isInfoActive = false
      }
      this.$emit('action', action)
    },
    onVideoAction(action) {
      console.log('onVideoAction', action)
      // re emit to parent
      this.$emit('videoaction', action)
    },
    // postMessageToiFrame called from outside / parent component
    postMessageToiFrame(payload) {
      let iFrameWindow = this.$refs.iFrame.contentWindow
      if (iFrameWindow) {
        iFrameWindow.postMessage(payload, '*')
      }
    }
  }
}

</script>

<style scoped lang="scss">
.info {}

svg {}
</style>
<style lang="scss">
@import 'styles';
</style>
